import AppForm from '../app-components/Form/AppForm';

Vue.component('dynamic-fields-form', {
    mixins: [AppForm],

    props: {
        'data': {
            type: Object,
            required: false,
            default: function() {
                return {};
            }
        },
        'sections': {
            type: Array,
            required: false,
            default: function() {
                return [];
            }
        },
    },

    data: function() {
        return {
            form: {},
            defaultForm: {
                scope: 1,
                section_id: null,
                order: 0,
                width: 6,
                type:  1,
                options: [],
                company_id: null
            }
        }
    },

    created: function() {
        if (!_.isEmpty(this.data) && this.data.id) {
            this.form = this.data;
        } else{
            this.form = Object.assign({}, this.defaultForm);
            if (this.data.section_id != null) {
                this.form.section_id = this.data.section_id;
            }
        }

        this.form.options = (this.data.options ? this.data.options : []);
        this.form.company_id = this.data.company_id;
        this.form.order = this.data.order != null ? this.data.order : (this.form.order != null ? this.form.order : 0);
        this.form.width = this.data.width != null ? this.data.width : (this.form.width != null ? this.form.width : 6);
        this.normalizeDynamicFieldOptions();
        this.ensureValidSectionSelected();
    },

    computed: {
        filteredSections: function() {
            var scope = parseInt(this.form.scope);
            return this.sections.filter(function(section) {
                return section.scope === scope;
            });
        }
    },

    watch: {
        // The sections offered by the form belong to the selected company, so the create form is
        // re-rendered for it. The company is then submitted from the form itself, not read from the
        // current restaurant on the server.
        'form.company_id': function(newVal, oldVal) {
            if (!_.isEmpty(this.data) && this.data.id) {
                return;
            }

            if (newVal == null || oldVal == null || newVal === oldVal) {
                return;
            }

            window.location.href = '/dynamic-fields/create?company_id=' + newVal;
        },

        'form.scope': function(newVal) {
            if (newVal != 1) {
                this.form.section_id = null;
            }

            this.ensureValidSectionSelected();
        },

        'form.type': function() {
            this.normalizeDynamicFieldOptions();
        }
    },

    methods: {
        getPostData()
        {
            var postData = Object.assign({}, this.form);

            if (parseInt(postData.type) === 3) {
                postData.options = (postData.options || [])
                    .map(function(option) {
                        return (option == null ? '' : String(option)).trim();
                    })
                    .filter(function(option) {
                        return option !== '';
                    });
            }

            if (parseInt(postData.type) === 6) {
                postData.options = (postData.options || [])
                    .map((subfield) => {
                        var selectOptions = [];
                        if (Array.isArray(subfield.select_options)) {
                            selectOptions = subfield.select_options;
                        } else if (subfield.select_options && typeof subfield.select_options === 'object') {
                            selectOptions = Object.keys(subfield.select_options).map(function(key) {
                                return subfield.select_options[key];
                            });
                        } else if (typeof subfield.select_options === 'string') {
                            selectOptions = subfield.select_options
                                .split(',')
                                .map(function(opt) {
                                    return opt.trim();
                                })
                                .filter(function(opt) {
                                    return opt !== '';
                                });
                        }

                        var pendingSelectOption = (subfield.select_option_input == null ? '' : String(subfield.select_option_input)).trim();
                        if (pendingSelectOption !== '') {
                            selectOptions.push(pendingSelectOption);
                        }

                        selectOptions = selectOptions
                            .map(function(opt) {
                                return (opt == null ? '' : String(opt)).trim();
                            })
                            .filter(function(opt) {
                                return opt !== '';
                            });

                        return {
                            label: (subfield.label || '').trim(),
                            type: this.normalizeRepeaterSubfieldType(subfield.type),
                            options: selectOptions,
                            checkbox_label: (subfield.checkbox_label || '').trim(),
                        };
                    })
                    .filter(function(subfield) {
                        return subfield.label !== '';
                    });
            }

            return postData;
        },

        normalizeDynamicFieldOptions()
        {
            if (!Array.isArray(this.form.options)) {
                this.form.options = [];
            }

            if (parseInt(this.form.type) === 3) {
                this.form.options = this.form.options.map(function(option) {
                    if (option && typeof option === 'object') {
                        return option.label ? option.label : '';
                    }

                    return option == null ? '' : String(option);
                });
                return;
            }

            if (parseInt(this.form.type) === 6) {
                this.form.options = this.form.options.map((option) => {
                    if (typeof option === 'string') {
                        return {
                            label: option,
                            type: 'text',
                            select_options: [],
                            select_option_input: '',
                            checkbox_label: '',
                        };
                    }

                    var mapped = option && typeof option === 'object' ? option : {};
                    var subfieldType = this.normalizeRepeaterSubfieldType(mapped.type);

                    var selectOptions = [];
                    if (Array.isArray(mapped.options)) {
                        selectOptions = mapped.options;
                    } else if (mapped.options && typeof mapped.options === 'object') {
                        selectOptions = Object.keys(mapped.options).map(function(key) {
                            return mapped.options[key];
                        });
                    } else if (typeof mapped.options === 'string') {
                        selectOptions = mapped.options.split(',');
                    } else if (Array.isArray(mapped.select_options)) {
                        selectOptions = mapped.select_options;
                    } else if (mapped.select_options && typeof mapped.select_options === 'object') {
                        selectOptions = Object.keys(mapped.select_options).map(function(key) {
                            return mapped.select_options[key];
                        });
                    } else if (typeof mapped.select_options === 'string') {
                        selectOptions = mapped.select_options.split(',');
                    }

                    return {
                        label: mapped.label ? mapped.label : '',
                        type: subfieldType,
                        select_options: selectOptions
                            .map(function(opt) {
                                return String(opt).trim();
                            })
                            .filter(function(opt) {
                                return opt !== '';
                            }),
                        select_option_input: '',
                        checkbox_label: mapped.checkbox_label ? mapped.checkbox_label : '',
                    };
                });
            }
        },

        normalizeRepeaterSubfieldType(type)
        {
            var normalized = type == null ? '' : String(type).trim().toLowerCase();

            if (normalized === '1') {
                return 'text';
            }

            if (normalized === '2') {
                return 'checkbox';
            }

            if (normalized === '3') {
                return 'select';
            }

            if (normalized === '4') {
                return 'date';
            }

            if (normalized === '5') {
                return 'price';
            }

            var allowedTypes = ['text', 'checkbox', 'select', 'date', 'price'];
            if (allowedTypes.indexOf(normalized) === -1) {
                return 'text';
            }

            return normalized;
        },

        addRepeaterSubfield()
        {
            this.form.options.push({
                label: '',
                type: 'text',
                select_options: [],
                select_option_input: '',
                checkbox_label: '',
            });
        },

        saveRepeaterSelectOption(subfield, continueAdding)
        {
            if (!subfield) {
                return;
            }

            var newOption = (subfield.select_option_input == null ? '' : String(subfield.select_option_input)).trim();
            if (newOption !== '') {
                if (!Array.isArray(subfield.select_options)) {
                    this.$set(subfield, 'select_options', []);
                }
                subfield.select_options.push(newOption);
                subfield.select_option_input = '';
            }
        },

        discardRepeaterSelectOption(subfield)
        {
            if (!subfield) {
                return;
            }

            subfield.select_option_input = '';
        },

        deleteRepeaterSelectOption(subfield, idx)
        {
            if (!subfield || !Array.isArray(subfield.select_options)) {
                return;
            }

            this.$delete(subfield.select_options, idx);
        },

        ensureValidSectionSelected()
        {
            var scope = parseInt(this.form.scope);
            var availableSections = this.sections.filter(function(section) {
                return parseInt(section.scope) === scope;
            });

            if (availableSections.length === 0) {
                this.form.section_id = null;
                return;
            }

            var currentSectionId = parseInt(this.form.section_id);
            var hasCurrentSection = availableSections.some(function(section) {
                return parseInt(section.id) === currentSectionId;
            });

            if (!hasCurrentSection) {
                this.form.section_id = availableSections[0].id;
            }
        },

        goBack()
        {
            window.location.href = '/dynamic-fields';
        },

        optionSave(continueAdding)
        {
            if($("#dynamicFieldOptionInput").val() != "")
            {
                this.form.options.push($("#dynamicFieldOptionInput").val());
                $("#dynamicFieldOptionInput").val("");
            }
            if(continueAdding)
            {
                $("#dynamicFieldOptionInput").focus();
            }
        },

        optionDiscard()
        {
            $("#dynamicFieldOptionInput").val("");
        },

        optionDelete(idx)
        {
            this.$delete(this.form.options, idx);
        },
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/dynamic-fields/Form.js